<section class="form-container" [attr.aria-label]="'base.field.contact_point.title' | transloco">
	<form class="form-grid" style="padding: 0" [formGroup]="form">
		<lvr-field [label]="'base.field.contact_point.categories' | transloco">
			<lvr-searchable-select
				formControlName="type"
				[options]="contactPointCategories()"
				[placeholder]="'base.field.select_please' | transloco"
				[searchPlaceholder]="'base.field.search_placeholder' | transloco"
				[noResultsText]="'base.field.no_results' | transloco"
				aria-required="true"
			></lvr-searchable-select>
		</lvr-field>

		@let contactValCtrl = form.get('contactValue');
		<lvr-field [label]="contactValueTitle()">
			<mat-form-field lvrInput [lvrError]="hasError(contactValCtrl, 'invalidPhone', 'pattern')">
				<input matInput formControlName="contactValue" placeholder="E-Mail oder Telefonnummer" />
			</mat-form-field>
			@if (hasError(contactValCtrl, 'invalidPhone')) {
				<mat-error>{{ 'base.form.error.phone_number_invalid' | transloco }}</mat-error>
			}
			@if (hasError(contactValCtrl, 'pattern')) {
				<mat-error>{{ 'base.form.error.email_invalid' | transloco }}</mat-error>
			}
		</lvr-field>
		<mat-checkbox [attr.aria-label]="'base.field.contact_point.preferred' | transloco" formControlName="preferred">{{
			'base.field.contact_point.preferred' | transloco
		}}</mat-checkbox>

		<lvr-field [label]="'base.field.remark' | transloco">
			<mat-form-field lvrInput>
				<input matInput formControlName="remark" placeholder="Eine Ergänzung wie z.B. Erreichbarkeit" />
			</mat-form-field>
		</lvr-field>
	</form>
</section>
